import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  DataForGettingLoanOffer,
  DataForGettingLoanOfferInFinancialCheckup,
  LoanOfferApi,
  LoanOfferProgress,
} from 'api/LoanOfferApi';
import { LocalStorageKeyName } from 'enums/LocalStorageKeyName';
import RequestError from 'errors/RequestError';

import { ErrorResponse } from './ErrorResponse';

export const createLoanOfferThunk = (api: LoanOfferApi) =>
  createAsyncThunk(
    'loanOffer/getLoanOffer',
    async (
      data: (DataForGettingLoanOffer | DataForGettingLoanOfferInFinancialCheckup) & {
        updateCallback?: (data: LoanOfferProgress) => void;
      },
      thunkApi,
    ) => {
      try {
        const { updateCallback, ...dataForGettingLoanOffer } = data;

        const loanOfferResult = await api.getLoanOffer(dataForGettingLoanOffer, updateCallback);

        localStorage.setItem(LocalStorageKeyName.LoanOfferResult, JSON.stringify(loanOfferResult));

        return loanOfferResult;
      } catch (error: unknown) {
        if (error instanceof RequestError) {
          return thunkApi.rejectWithValue(error.toJson());
        }
        return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
      }
    },
  );

export default createLoanOfferThunk;
